export default {
  pt: {
    mainTitle: "Seguro gratuito para você!",
    description: "A loja onde você comprou a sua {brand} {model} tem um presente para você:",
    freeInsuranceText: "Seguro grátis contra furto e roubo!",
    benefitText: "Para obter este benefício, siga os passos até o final.",
    freeBasicButton: "Quero o Seguro Básico Grátis",
    premiumButton: "Prefiro pagar pelo Premium",
  },

  en: {
    mainTitle: "Free insurance for you!",
    description: "The store where you bought your {brand} {model} has a gift for you:",
    freeInsuranceText: "Free insurance against theft and robbery!",
    benefitText: "To get this benefit, follow the steps to the end.",
    freeBasicButton: "I want the Free Basic Insurance",
    premiumButton: "I prefer to pay for Premium",
  },
}; 